import React, { forwardRef } from 'react';
import type { MenuItemProps } from '@mui/material';
import { MenuItem as MenuItemMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

interface Props extends Omit<MenuItemProps, 'value'> {
  to?: string;
  value?: boolean | string | readonly string[] | number;
}

const MenuItem = forwardRef<HTMLLIElement, Props>((props, ref) => (
  <MenuItemMUI {...omitUndefinedProps(props)} ref={ref} />
));

MenuItem.displayName = 'MenuItem';

export default MenuItem;
